import createMenuConfig from "./createMenuConfig";
import {utahHeaderLoaded} from "../../components/UtahHeader/UtahHeader";

export default configuratorStore => utahHeaderLoaded.then(() => utahHeader.setMainMenu(createMenuConfig(configuratorStore.mainMenu)));
